import { alertService } from 'components/Varios/alert_service';
import ModalConfirmacion from 'components/Varios/Modals/ModalConfirmacion';
import ModalVistaPreviaDocumentosAccion from 'components/Varios/Modals/ModalVistaPreviaDocumento';
import ComponentePaginacionTabla from 'components/Varios/Tabla/ComponentePaginacionTabla';
import { ObtenerFechaFromIsoFormat } from 'functions/DatesFunctions';
import { getTdTableStyles } from 'helpers/Table/tableFunctions';
import React, { useCallback, useState, useMemo } from 'react';
import { useTable, Column, Accessor, HeaderGroup, useGlobalFilter, usePagination, useSortBy, useRowSelect } from "react-table";
import { Container, Table, Col, Label, Input, Button } from 'reactstrap'
import RowNoMargin  from 'components/Varios/RowNoMargin'
import { GlobalFilterTable } from 'components/Varios/Tabla/GlobalFilterTable';

import {
    AprobarSolicitudJustificacion,
    DirectivoAprobadorObtenerVistaPreviaFormularioJustificacion,
    RechazarSolicitudJustificacion,
    AprobarParcialmenteSolicitudJustificacion,
    AprobarMasivaSolicitudes
} from './FunctionsAprobacionSolicitudes';
import {TipoFiltroSolicitudAprobar, TipoSolicitud, EstadoSolicitudGestion, ID_SOLICITUD_RECUPERACION_MARCACION } from './TypesAprobacionSolicitudes';

import ModalRechazo from "./ModalRechazoSolicitud"
import { FormGroup } from 'react-bootstrap';
import { authenticationService } from 'services/authentication.service';


import PDFViewer from "components/Varios/PDFViewer";
import Cargando from 'components/Varios/Cargando';
import ModalCargando from 'components/Varios/ModalCargando';
import { Checkbox } from 'components/Varios/Tabla/CheckBoxTable';

import "../../../assets/scss/TablaAprobacionSolicitudesMasivas.scss";

export default function TableSolicitudesAprobar({ dataprops, recargarInformacionTabla, tipoFiltroSolicitud, filtrarTiposSolicitud , Actualizar}) {


    const defaultStateInformacionModalAprobarJustificacion = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        modalContent: undefined,
        tituloModal: "",
        tipo: "Aprobar"
    }

    const defaultStateInformacionModalAprobarParcialmenteJustificacion = {
        tituloModal: "",
        cargando: false,
        idSolicitud: -1,
        contentBody: undefined
    }


    const defaultStateInformacionModalNegarJustificacion = {
        url: "",
        cargando: false,
        idSolicitud: -1,
        contentBody: undefined,
        observacion: ""
    }

    const defaultSateModalAprobacionMasivaSolicitudes = {
        cargando: false,
        listadoSolicitudesAprobar: [],
        contentBody: undefined
    }



    const [stateinformacionModalAprobarJustificacion, setstateinformacionModalAprobarJustificacion] = useState(defaultStateInformacionModalAprobarJustificacion)
    const [stateinformacionModalAprobarParcialmenteJustificacion, setstateinformacionModalAprobarParcialmenteJustificacion] = useState(defaultStateInformacionModalAprobarParcialmenteJustificacion)
    const [stateinformacionModalNegarJustificacion, setstateinformacionModalNegarJustificacion] = useState(defaultStateInformacionModalNegarJustificacion)

    //Aprobacion Masiva
    const [stateModalAprobacionMasivaSolicitudes, setstateModalAprobacionMasivaSolicitudes] = useState(defaultSateModalAprobacionMasivaSolicitudes)

    const [observacion, setobservacion] = useState("")
    const data = React.useMemo(
        () => [...dataprops], [dataprops]
    )


    async function OnClickAccionModalFormulario(idSolicitud) {
        setstateinformacionModalAprobarJustificacion({ cargando: true })
        var accionRealizada = await AprobarSolicitudJustificacion(idSolicitud)
        setstateinformacionModalAprobarJustificacion(defaultStateInformacionModalAprobarJustificacion)
        await recargarInformacionTabla();
    }

   

    async function onClickAprobarSolicitudJustificacion(informacionAcciones) {
        setstateinformacionModalAprobarJustificacion({ ...defaultStateInformacionModalAprobarJustificacion, cargando: true })
        
        var respuesta = await DirectivoAprobadorObtenerVistaPreviaFormularioJustificacion(informacionAcciones.idSolicitud, EstadoSolicitudGestion.APROBACIONUNIDAD);



        if (respuesta.status === 200) {

            const tituloModal = informacionAcciones.idTipoPermiso === 41 ? "SOLICITUD JUSTIFICACIÓN MARCACIÓN" : "SOLICITUD RECUPERACIÓN TIEMPO NO LABORADO";

            setstateinformacionModalAprobarJustificacion({
                url: respuesta.dataResponse,
                cargando: false,
                idSolicitud: informacionAcciones.idSolicitud,
                modalContent: AuxiliarGenerarHTMLBodyModalInformacionVacacionesPendientes(informacionAcciones),
                tituloModal,
                tipo: "Aceptar"

            })
        }
        else {
            setstateinformacionModalAprobarJustificacion(defaultStateInformacionModalAprobarJustificacion)
            alertService.error(respuesta.errorMessage ?? "No pudo obtenerse la vista Previa de Solicitud ");
        }
    }


    function onClickAprobarParcialmenteSolicitudJustificacion(informacionAcciones) {



        const contentBody = AuxiliarGenerarHTMLBodyModalInformacionVacacionesPendientes(informacionAcciones);



        setstateinformacionModalAprobarParcialmenteJustificacion({
            cargando: false,
            idSolicitud: informacionAcciones.idSolicitud,
            contentBody,
            tituloModal: "Autorizar solicitud"
        })
    }

   




    const ModalAprobarSolicitudJustificacion = useMemo(() => {
        return (
            <ModalVistaPreviaDocumentosAccion
                show={stateinformacionModalAprobarJustificacion.url !== "" || stateinformacionModalAprobarJustificacion.cargando}
                accionOnAccept={true}
                cargandoDatos={stateinformacionModalAprobarJustificacion.cargando}
                onClose={() => setstateinformacionModalAprobarJustificacion(defaultStateInformacionModalAprobarJustificacion)}
                size="xl"
                tituloModal={stateinformacionModalAprobarJustificacion.tituloModal}
                urlArchivo={stateinformacionModalAprobarJustificacion.url}
                asyncAccion={() => OnClickAccionModalFormulario(stateinformacionModalAprobarJustificacion.idSolicitud)}
                nombreBotonAccion={stateinformacionModalAprobarJustificacion.tipo}
                disabledbuttonCondition={stateinformacionModalAprobarJustificacion.cargando}
                modalContent={stateinformacionModalAprobarJustificacion.modalContent}


            />

        )
    }, [stateinformacionModalAprobarJustificacion])

    const ModalNegarSolicitudJustificacion = useMemo(() => {

        return (
            <ModalConfirmacion
                show={stateinformacionModalNegarJustificacion.idSolicitud > 0 || stateinformacionModalNegarJustificacion.cargando}                
                size="lg"
                onClose={() => setstateinformacionModalNegarJustificacion(defaultStateInformacionModalNegarJustificacion)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea No autorizar la solicitud?"}
                nombreBotonAccion={"Aceptar"}
                nombreBotonCerrarModal={"Cancelar"}
                asyncOnClick={() => RechazarSolicitudJustificacion(stateinformacionModalNegarJustificacion.idSolicitud)}
                contentModal={stateinformacionModalNegarJustificacion.contentBody}
                tituloModal={"No autorizar la solicitud "}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                labelObservacion={"Indique el motivo"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={200}
                cargando={stateinformacionModalNegarJustificacion.cargando}

            />
        )
        


    // return (
    //     <ModalRechazo
    //         show={stateinformacionModalNegarJustificacion.idSolicitud > 0 || stateinformacionModalNegarJustificacion.cargando}
    //         urlContent={stateinformacionModalNegarJustificacion.url}
    //         size="lg"
    //         onClose={() => setstateinformacionModalNegarJustificacion(defaultStateInformacionModalNegarJustificacion)}
    //         asyncAccion={true}
    //         asyncClose={true}
    //         closeAfterAccion={true}
    //         hideBotonCerrar={false}
    //         mensajeConfirmacion={"¿Está seguro/a que desea No autorizar la solicitud?"}
    //         nombreBotonAccion={"SI"}
    //         nombreBotonCerrarModal={"NO"}
    //         asyncOnClick={(observacion) => RechazarSolicitudJustificacion(stateinformacionModalNegarJustificacion.idSolicitud, { Observacion: observacion })}
    //         contentModal={stateinformacionModalNegarJustificacion.contentBody}
    //         tituloModal={"No autorizar la solicitud "}
    //         asyncAfterOnClose={() => recargarInformacionTabla()}
    //         labelObservacion={"Indique el motivo"}
    //         botonesAccionParteSuperior={true}
    //         classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
    //         maxLength={200}
    //         cargando={stateinformacionModalNegarJustificacion.cargando}

    //     />
    // )
}, [stateinformacionModalNegarJustificacion])

const ModalAprobacionParcial = useMemo(() => {
    return (
        <ModalConfirmacion
            show={stateinformacionModalAprobarParcialmenteJustificacion.idSolicitud > 0 || stateinformacionModalAprobarParcialmenteJustificacion.cargando}
            size="lg"
            onClose={() => setstateinformacionModalAprobarParcialmenteJustificacion(defaultStateInformacionModalAprobarParcialmenteJustificacion)}
            asyncAccion={true}
            asyncClose={true}
            closeAfterAccion={true}
            hideBotonCerrar={false}
            mensajeConfirmacion={"¿Está seguro/a que desea autorizar la solicitud ?"}
            nombreBotonAccion={"Aceptar"}
            nombreBotonCerrarModal={"Cancelar"}
            asyncOnClick={() => AprobarParcialmenteSolicitudJustificacion(stateinformacionModalAprobarParcialmenteJustificacion.idSolicitud)}
            contentModal={stateinformacionModalAprobarParcialmenteJustificacion.contentBody}
            tituloModal={stateinformacionModalAprobarParcialmenteJustificacion.tituloModal}
            asyncAfterOnClose={() => recargarInformacionTabla()}
            botonesAccionParteSuperior={true}
            classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}

        />)
}, [stateinformacionModalAprobarParcialmenteJustificacion])

const ModalAprobacionMasivaSolicitudVacaciones = useMemo(() => {
    return (
        <ModalConfirmacion
            show={stateModalAprobacionMasivaSolicitudes.listadoSolicitudesAprobar.length > 0}
            size="lg"
            onClose={() => setstateModalAprobacionMasivaSolicitudes(defaultSateModalAprobacionMasivaSolicitudes)}
            asyncAccion={true}
            asyncClose={true}
            closeAfterAccion={true}
            hideBotonCerrar={false}
            mensajeConfirmacion={"¿Está seguro/a que desea aprobar las siguientes solicitudes"}
            nombreBotonAccion={"ACEPTAR"}
            nombreBotonCerrarModal={"CANCELAR"}
            asyncOnClick={() => AprobarMasivaSolicitudes(stateModalAprobacionMasivaSolicitudes.listadoSolicitudesAprobar)}
            contentModal={stateModalAprobacionMasivaSolicitudes.contentBody}
            tituloModal={"Aprobación masiva solicitudes"}
            asyncAfterOnClose={() => recargarInformacionTabla()}
            botonesAccionParteSuperior={true}

        />


    )
}, [stateModalAprobacionMasivaSolicitudes])



async function onClickNegarSolicitudJustificacion(informacionAcciones) {
    setstateinformacionModalNegarJustificacion({ ...defaultStateInformacionModalNegarJustificacion, cargando: true })

    var respuesta = await DirectivoAprobadorObtenerVistaPreviaFormularioJustificacion(informacionAcciones.idSolicitud,EstadoSolicitudGestion.NEGADOUNIDAD);



    if (respuesta.status === 200) {

        const tituloModal = informacionAcciones.idTipoPermiso === 41 ? "SOLICITUD JUSTIFICACIÓN MARCACIÓN" : "SOLICITUD RECUPERACIÓN TIEMPO NO LABORADO";

        setstateinformacionModalNegarJustificacion({
            cargando: false,
            idSolicitud: informacionAcciones.idSolicitud,
            contentBody: AuxiliarGenerarHTMLBodyModalInformacionVacacionesPendientes(informacionAcciones,respuesta.dataResponse),
            tituloModal,
            url: respuesta.dataResponse
        })
    }
    else {
        setstateinformacionModalNegarJustificacion(defaultStateInformacionModalNegarJustificacion)
        alertService.error(respuesta.errorMessage ?? "No pudo obtenerse la vista Previa de Solicitud ");
    }
}



function onClickAprobacionMasiva(solicitudesAprobar) {

    const contentBody = (
        <>

            <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                <thead className="cabecerasDetallehistorialSolic">
                    <tr className="" >
                        <th>Tipo</th>
                        <th> Fecha Solicitud</th>
                        <th> Nombre</th>
                        <th> Fecha </th>
                        <th> Hora Desde</th>
                        <th> Hora Hasta</th>
                    </tr>
                </thead>
                <tbody>

                    {solicitudesAprobar.map((solicitudes, ind) => {
                        const informacionAcciones = solicitudes.acciones;
                        return (
                            <tr key={"trMasivoSolicVac" + ind} className="rowHistorialSolicitudVacaciones">
                                <td className="">
                                    <div className="">
                                        {informacionAcciones.tiposolicitud}
                                    </div>

                                </td>
                                <td className="">
                                    <div className="">
                                        {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                                    </div>

                                </td>
                                <td className="">
                                    <div className="">
                                        {informacionAcciones.nombres}
                                    </div>

                                </td>
                                <td className="">
                                    <div className="">
                                        {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
                                    </div>

                                </td>
                                <td className="">
                                    <div className="">
                                        {informacionAcciones.horaDesde}
                                    </div>

                                </td>

                                <td className="">
                                    <div className="">
                                        {informacionAcciones.horaHasta}
                                    </div>

                                </td>

                               

                            </tr>
                        )
                    })}

                </tbody>
            </Table>
        </>

    )

    setstateModalAprobacionMasivaSolicitudes({
        cargando: false,
        listadoSolicitudesAprobar: solicitudesAprobar,
        contentBody


    })
}








function AuxiliarGenerarHTMLBodyModalVacaciones(informacionAcciones) {
    const esPermisoPorHora = informacionAcciones.horaDesde !== "" && informacionAcciones.horaHasta !== "" && informacionAcciones.horasTotal !== "";
    const contentBody = (
        <>

            <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                <thead className="cabecerasDetallehistorialSolic">
                    <tr className="" >
                        <th> Fecha Solicitud</th>
                        <th> Nombre</th>
                        {
                            !esPermisoPorHora &&
                            (
                                <>
                                    <th> Fecha Desde</th>
                                    <th> Fecha Hasta</th>
                                </>

                            )
                        }
                        {
                            esPermisoPorHora &&
                            (
                                <>
                                    <th> Fecha </th>
                                    <th> Hora Desde </th>
                                    <th> Hora Hasta </th>
                                    <th> Total Horas </th>
                                </>
                            )
                        }

                        <th> Estado</th>
                        <th> Días Ordinarios</th>

                    </tr>
                </thead>
                <tbody>

                    <tr className="rowHistorialSolicitudVacaciones">
                        <td className="">
                            <div className="">
                                {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                            </div>

                        </td>
                        <td className="">
                            <div className="">
                                {informacionAcciones.nombres}
                            </div>

                        </td>
                        {
                            !esPermisoPorHora &&
                            (
                                <>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaHasta)}
                                        </div>

                                    </td>
                                </>

                            )
                        }

                        {
                            esPermisoPorHora &&
                            (
                                <>
                                    <td className="">
                                        <div className="">
                                            {ObtenerFechaFromIsoFormat(informacionAcciones.fechaDesde)}
                                        </div>

                                    </td>
                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.horaDesde}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.horaHasta}
                                        </div>
                                    </td>
                                    <td className="">
                                        <div className="">
                                            {informacionAcciones.horasTotal}
                                        </div>
                                    </td>
                                </>

                            )
                        }



                        <td className="">
                            <div className="">
                                {informacionAcciones.estadoParse}
                            </div>

                        </td>


                        <td className="">
                            <div className="">
                                {informacionAcciones.diaOrdinario + " día(s) ordinario(s)"}
                            </div>

                        </td>

                    </tr>

                </tbody>
            </Table>
        </>

    )

    return contentBody;
}

function AuxiliarGenerarHTMLBodyModalInformacionVacacionesPendientes(informacionAcciones, urlArchivo) {
    var correspondienteA= "";

    if (informacionAcciones && informacionAcciones.idTipoPermiso === ID_SOLICITUD_RECUPERACION_MARCACION) {
        correspondienteA = "Solicitud Recuperación";
    }
    else if (informacionAcciones && informacionAcciones.subTipoDescripcion) {
        correspondienteA = informacionAcciones.subTipoDescripcion;
    }



    const contentBody = (
        <>

            <Table bordered className="tableHistorialSolicitudesVacaciones" responsive>
                <thead className="cabecerasDetallehistorialSolic">
                    <tr className="" >
                        <th> Fecha Solicitud</th>
                        <th> Nombre</th>
                        <th> Correspondiente a:</th>
                        <th> Fecha </th>
                        <th> Hora desde</th>
                        <th> Hora Hasta</th>
                        <th> Observación</th>


                    </tr>
                </thead>
                <tbody>

                    <tr className="rowHistorialSolicitudVacaciones">
                        <td className="">
                            <div className="">
                                {ObtenerFechaFromIsoFormat(informacionAcciones.fechaSolicitud)}
                            </div>

                        </td>
                        <td className="">
                            <div className="">
                                {informacionAcciones.nombres}
                            </div>

                        </td>
                        <td className="">
                            <div className="">
                                {correspondienteA}
                            </div>

                        </td>                        
                        <td className="">
                            <div className="">
                                {ObtenerFechaFromIsoFormat(informacionAcciones.fechaHasta)}
                            </div>

                        </td>
                        <td className="">
                            <div className="">
                                {informacionAcciones.horaDesde}
                            </div>

                        </td>
                        <td className="">
                            <div className="">
                                {informacionAcciones.horaHasta}
                            </div>

                        </td>

                        <td className="">
                            <div className="">
                                {informacionAcciones.observacion}
                            </div>

                        </td>





                    </tr>

                </tbody>
            </Table>

            {urlArchivo &&
                    <RowNoMargin>
                        <Col>
                            <PDFViewer url={urlArchivo} heightValue={"100%"} />

                        </Col>
                    </RowNoMargin>
                }

        </>

    )

    return contentBody;
}



function GenerarCellAcciones(informacionAcciones) {
    if (informacionAcciones === undefined || informacionAcciones === null) {
        return <span></span>
    }
    else if ((informacionAcciones.estado === EstadoSolicitudGestion.INGRESO || informacionAcciones.estado === EstadoSolicitudGestion.APROBACIONPARCIALUNIDAD) && informacionAcciones.aprueba === "S") {

        

        const iconoAprobar = (
            <i
                className="fa-regular fa-circle-check acciones"
                data-toggle="tooltip" data-placement="top" title="Autorizar"

                onClick={() => onClickAprobarSolicitudJustificacion(informacionAcciones) }
            >
            </i>
        )

        const iconoNegar = (
            <i
                onClick={() => onClickNegarSolicitudJustificacion(informacionAcciones)}
                className="fa-regular fa-circle-xmark ml-2 acciones"
                data-toggle="tooltip" data-placement="top" title="NO Autorizar"

            ></i>

        )

        const contentAccion = (
            <React.Fragment>


                {iconoAprobar}
                {iconoNegar}

            </React.Fragment>
        )
        return contentAccion

    }
    
    else if (informacionAcciones.estado === EstadoSolicitudGestion.INGRESO && informacionAcciones.aprueba === "N") {
        const iconoAprobar = (
            <i
                className="fa-regular fa-circle-check acciones"
                onClick={() => onClickAprobarParcialmenteSolicitudJustificacion(informacionAcciones)}
                data-toggle="tooltip" data-placement="top" title="Aprobar"
            >
            </i>
        )

        const iconoNegar = (
            <i
                onClick={() => onClickNegarSolicitudJustificacion(informacionAcciones)}
                className="fa-regular fa-circle-xmark ml-2 acciones"
                data-toggle="tooltip" data-placement="top" title="Negar"

            ></i>

        )
        const contentAccion = (
            <React.Fragment>


                {iconoAprobar}
                {iconoNegar}

            </React.Fragment>
        )
        return contentAccion
    }
    else {
        return <div />
    }
}

function ObtenerHoraSegunSubtipo(celda,tipohora){
        
    
    const value = celda.row.original.acciones;
    var hora = tipohora === "d" ? value.horaDesde : value.horaHasta
    if(value.subTipo === "IR" || value.subTipo === "LI"){
        return <div>{tipohora === "d" ? "":hora}</div>
    }
    else if (value.subTipo === "FR" || value.subTipo === "LF"){        
        return <div>{tipohora === "h" ? "":hora}</div>
    }
    else{
        return <div>{hora}</div>
    }
}

const column_usando = React.useMemo(
    () => [
        {
            Header: "Tipo de Solicitud",
            accessor: "tipoSolicitud"
        },
        {
            Header: 'Fecha Solicitud',
            accessor: 'fechaSolicitud',
            Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
        },
        {
            Header: 'Fecha Vencimiento',
            accessor: 'fechaVencimiento',
            Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
        },
        {
            Header: 'Nombres',
            accessor: 'nombres',
        },
        {
            Header: 'Fecha',
            accessor: 'fechaDesde',
            Cell: ({ value }) => ObtenerFechaFromIsoFormat(value)
        },
        {
            Header: 'Hora Desde',
            accessor: 'horaDesde',
            Cell: ( value ) => ObtenerHoraSegunSubtipo(value,"d")
        },
        {
            Header: 'Hora Hasta',
            accessor: 'horaHasta',
            Cell: ( value ) => ObtenerHoraSegunSubtipo(value,"h")
        },
        {
            Header: 'Estado',
            accessor: 'estadoParse',
        },
        {
            Header: 'Observaciones',
            accessor: 'observacion',
        },
        {
            Header: "Acciones",
            accessor: 'acciones',
            Cell: ({ value }) => GenerarCellAcciones(value)
        }
    ], [dataprops]
)


function ShowCheckBoxCondition(dataRow) {
    return dataRow  && dataRow.acciones.estado !== "V" ;
}

const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    nextPage,
    previousPage,
    canNextPage,
    canPreviousPage,
    pageOptions,
    setPageSize,
    selectedFlatRows,
    prepareRow,
    state,
    setGlobalFilter,
    getToggleHideAllColumnsProps,
    getToggleAllPageRowsSelectedProps,
    toggleRowSelected

} = useTable(
    {
        columns: column_usando,
        data
    },
    useGlobalFilter,
    useSortBy,
    usePagination,
    useRowSelect,
    (hooks) => {
        hooks.visibleColumns.push((columns) => {
            return [
                {
                    id: 'selection',
                    Header: ({ getToggleAllPageRowsSelectedProps }) => (
                        <Checkbox
                            isHeader={true}
                            {...getToggleAllPageRowsSelectedProps()}
                        />
                    ),
                    Cell: ({ row }) => (
                        <Checkbox
                            condition={ShowCheckBoxCondition(row.values)}
                            {...row.getToggleRowSelectedProps()}

                        />
                    )

                },
                ...columns
            ]
        })
    }
)

const { globalFilter, pageIndex, pageSize } = state;
const sizerows = data.length;




const columnasStyles = (cell) => {
    return ([
        {
            HeaderName: "Nombres",
            StyleHeader: {
                textAlign: "left"
            }
        },
        {
            HeaderName: "Estado",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Días Ordinarios",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Días Pendientes por Gozar",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Tipo de Solicitud",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Desde",
            StyleHeader: {
                textAlign: "center"
            }
        },
        {
            HeaderName: "Fecha Hasta",
            StyleHeader: {
                textAlign: "center",
                width: "100px"
            }
        },
        {
            HeaderName: "Fecha Solicitud",
            StyleHeader: {
                textAlign: "center",
                
            }
        },
        {
            HeaderName: "Fecha Vencimiento",
            StyleHeader: {
                textAlign: "center",
                width: "100px",
                color:"red"
            }
        },
        {
            HeaderName: "Observaciones",
            StyleHeader: {
                textAlign: "justify",
                width: "200px"

            }
        }
    ])
}

const ButtonAprobacionMasiva = useMemo(() => {

    const nombreBotonAprobarMasivo = "Aprobar todas las solicitudes seleccionadas";
    if (selectedFlatRows.length === 1) {
        var filaSeleccionada = selectedFlatRows[0].original;
        if ( filaSeleccionada.estado !== "V") {

            if (filaSeleccionada.aprueba === "S") {
                return <Button className="fleft" onClick={() => onClickAprobarSolicitudJustificacion(filaSeleccionada.acciones)} >Aprobar Solicitud </Button>
            }
            else {
                return <Button className="fleft" onClick={() => onClickAprobarParcialmenteSolicitudJustificacion(filaSeleccionada.acciones)} >Aprobar Solicitud </Button>
            }

        }
        else {
            return <Button className="fleft" disabled>Aprobar Solicitud </Button>
        }
    }

    else if (selectedFlatRows.length > 1) {
        var filasSeleccionadas = selectedFlatRows;
        var filasMapeadas = [];
        filasSeleccionadas.forEach(element => {
            if ( element.original.estado !== "V") {
                filasMapeadas.push(element.original)
            }
        });

        if (filasMapeadas.length > 0) {
            return (<Button className="fleft" onClick={() => onClickAprobacionMasiva(filasMapeadas)} >{nombreBotonAprobarMasivo} </Button>)
        }
        else if (filasMapeadas.length <= 0) {
            return (<Button className="fleft" disabled >{nombreBotonAprobarMasivo} </Button>)
        }
    }
    else {
        return <Button className="fleft" disabled>{nombreBotonAprobarMasivo}</Button>
    }

}, [selectedFlatRows])



const ButtonFiltrarPermisosSolicitudesVacaciones = useMemo(() => {

    return (
        <>
            <Label>Filtrar solicitudes: </Label>
            <Input value={tipoFiltroSolicitud} type="select" onChange={(e) => filtrarTiposSolicitud(e.target.value)} >
                <option value={TipoFiltroSolicitudAprobar.TODOS}>Aprobables / No vencidas</option>
                <option value={TipoFiltroSolicitudAprobar.MARCACIONES_VENCIDAS}>Vencidas</option>
            </Input>
        </>

    )

    // return <Button className="fleft" onClick={() => filtrarTiposSolicitud(TipoFiltroSolicitudAprobar.VACACIONES_Y_PERMISOS)} >Mostrar Solicitudes de Vacaciones y Permisos </Button>
}, [selectedFlatRows])



return (
    <React.Fragment>
       
        <RowNoMargin  className={"mb-3 rowBotonFiltroAprobacionMasivaSolicitudes"}>

            <Col xl={2}>
                {ButtonFiltrarPermisosSolicitudesVacaciones}
            </Col>
            <Col xl={2}>
                    <div className='containerBotonAprobMasivaSolicitudes'>
                        {ButtonAprobacionMasiva}
                    </div>


                </Col>
        </RowNoMargin>

        <RowNoMargin className="justify-content-start">
            <Col className="col-left">
                <Button onClick={()=> Actualizar() }> Actualizar Tabla </Button>
            </Col>
        </RowNoMargin>

        <RowNoMargin className={"mb-2"}>

            <Col>
                <div className='small-error'>{tipoFiltroSolicitud === TipoFiltroSolicitudAprobar.MARCACIONES_VENCIDAS ? "Está visualizando solicitudes vencidas (no fueron aprobadas en el tiempo máximo). Para visualizar las solicitudes que puede aprobar, utilice el filtro de la parte superior" : ""}</div>
            </Col>
        </RowNoMargin>
        <RowNoMargin>
            <Col xl={12}>
                <GlobalFilterTable
                    filter={globalFilter}
                    setFilter={setGlobalFilter}
                />
            </Col>
        </RowNoMargin>
        <RowNoMargin>
            <Col xl={12}>
                <Table responsive {...getTableProps()} style={{ border: 'solid 1px ' }} className="tablesReact" >
                    <thead style={{}}>
                        {headerGroups.map(headerGroup => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup.headers.map(column => (
                                    <th
                                        {...column.getHeaderProps(column.getSortByToggleProps())}
                                        style={{ width: column.Header === "Observaciones" ? "300px" : "auto" }}
                                        className='clickable'
                                    >
                                        {column.render('Header')}
                                        <span>
                                            {column.isSorted ? (column.isSortedDesc ? '⬆️' : '⬇️') : ''}
                                        </span>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {page.map((row, indirow) => {
                            prepareRow(row)
                            return (
                                <tr {...row.getRowProps()}>

                                    {row.cells.map(cell => {
                                        return getTdTableStyles(cell, { border: 'solid 1px black' },indirow ,columnasStyles(cell))

                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </Table>
                <ComponentePaginacionTabla
                    page={page}
                    sizerows={sizerows}
                    canNextPage={canNextPage}
                    canPreviousPage={canPreviousPage}
                    nextPage={nextPage}
                    pageIndex={pageIndex}
                    pageOptions={pageOptions}
                    pageSize={pageSize}
                    previousPage={previousPage}
                    setPageSize={setPageSize}

                />
            </Col>
        </RowNoMargin>





        {/* Aprobacion Parcial de Vacaciones */}
        {/* <ModalConfirmacion
                show={stateinformacionModalAprobarParcialmenteVacaciones.idSolicitudVacaciones > 0 || stateinformacionModalAprobarParcialmenteVacaciones.cargando}
                size="lg"
                onClose={() => setstateinformacionModalAprobarParcialmenteVacaciones(defaultStateInformacionModalAprobarParcialmenteVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea aprobar la solicitud de vacaciones?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={() => AprobarParcialmenteSolicitudVacaciones(stateinformacionModalAprobarParcialmenteVacaciones.idSolicitudVacaciones)}
                contentModal={stateinformacionModalAprobarParcialmenteVacaciones.contentBody}
                tituloModal={stateinformacionModalAprobarParcialmenteVacaciones.tituloModal}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                classNameAllModal={""}


            />

            <ModalRechazo
                show={stateinformacionModalRechazarVacaciones.idSolicitudVacaciones > 0 || stateinformacionModalRechazarVacaciones.cargando}
                size="lg"
                onClose={() => setstateinformacionModalRechazarVacaciones(defaultStateInformacionModalRechazarVacaciones)}
                asyncAccion={true}
                asyncClose={true}
                closeAfterAccion={true}
                hideBotonCerrar={false}
                mensajeConfirmacion={"¿Está seguro/a que desea negar la solicitud de vacaciones?"}
                nombreBotonAccion={"SI"}
                nombreBotonCerrarModal={"NO"}
                asyncOnClick={(observacion) => RechazarVacaciones(stateinformacionModalRechazarVacaciones.idSolicitudVacaciones, { Observacion: observacion })}
                contentModal={stateinformacionModalRechazarVacaciones.contentBody}
                tituloModal={"Negar Solicitud de Vacaciones"}
                asyncAfterOnClose={() => recargarInformacionTabla()}
                labelObservacion={"Indique el motivo de negación"}
                botonesAccionParteSuperior={true}
                classNamemensajeConfirmacion={"mensajeModalsSolicitudVacaciones"}
                maxLength={500}

            /> */}

        {ModalAprobarSolicitudJustificacion}
        {ModalAprobacionParcial}
        {ModalNegarSolicitudJustificacion}

        {ModalAprobacionMasivaSolicitudVacaciones}

    </React.Fragment>
)


}
